<template>
	<div>
		<div class="logged-in" @click="handleAccountClick" v-if="isLoggedIn">
			<FontAwesomeIcon :icon="faUserCog" v-if="!loginProgress" />
			<Spinner v-if="loginProgress" size="sm" color="gold" />
		</div>
		<div class="not-logged-in" @click="handleLoginClick" v-if="!isLoggedIn">
			<BasicButton :color="color" class="not-logged-in__button">
				<span v-if="dark">{{ $t('WEBAPP_NAVBAR_SIGN_IN_BUTTON') }}</span>
				<span v-else>{{ $t('WEBAPP_NAVBAR_JOIN_NOW_BUTTON') }}</span>
			</BasicButton>

			<FontAwesomeIcon :icon="faUserCog" class="not-logged-in__icon" />
		</div>
	</div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import { useUserStore } from '@/stores/pinia/useUserStore';
import BasicButton from '@/ui-components/BasicButton.vue';
import { AccountModal, SettingsModal } from '@/lazy-load-components';
import { faUserCog } from '@fortawesome/free-solid-svg-icons';
import Spinner from '@/ui-components/Spinner.vue';

import { ModalHelper } from '@/helpers/vfm/modal-helper';

const props = defineProps<{ dark: boolean }>();

const userStore = useUserStore();
const { setLoginProgress } = userStore;
const { loginProgress, isLoggedIn } = storeToRefs(userStore);

const isLightTheme = computed(() => {
	return false;
	//return country.value === 'GB' && activeRoute.value.path === '/' && !isUserOnboarded.value;
});

const color = computed(() => {
	if (isLightTheme.value) {
		return 'ghost';
	}
	return props.dark ? 'dark' : 'primary';
});

function handleAccountClick() {
	ModalHelper.openModal(SettingsModal, {}, { id: 'settings' });
}

function handleLoginClick() {
	ModalHelper.openModal(AccountModal, { closable: true }, { cssClass: 'login-modal' }, '', false, [], () => {
		setLoginProgress(true);
	});
}
</script>

<style lang="scss" scoped>
@import '~@/styles/variables.scss';

.logged-in {
	height: 100%;
	padding: 0 15px;
	display: flex;
	align-items: center;
	color: var(--jw-color-primary);
	font-size: 18px;
}

.not-logged-in {
	height: 100%;
	display: flex;
	align-items: center;

	&__button {
		@media (max-width: $breakpoint-two-rows) {
			display: none;
		}
		//STARTER_PAGE_EXP
		&.ghost {
			padding-inline: 24px;
			border: none;
			border-radius: 8px;
			font-weight: 700;
			font-size: 14px;
		}
		//STARTER_PAGE_EXP
	}

	&__icon {
		display: none;
		font-size: 16px;
		cursor: pointer;

		@media (max-width: $breakpoint-two-rows) {
			display: block;
		}
	}

	@media (max-width: $breakpoint-two-rows) {
		padding: 0 15px;
	}
}
</style>
